import type { CompanyInformation, ManagerId, UpdateManagerPayload } from '../generated-types';
import { CONTEXT_PATH } from './index';
import { get, put } from './request';

const SERVICE_PATH = 'rest/resource/company';

export async function getCompanyInformation(): Promise<CompanyInformation> {
    return get(`${CONTEXT_PATH}/${SERVICE_PATH}`);
}

export async function updateGeneralManager(id: ManagerId, payload: UpdateManagerPayload): Promise<void> {
    return put(`${CONTEXT_PATH}/${SERVICE_PATH}/${id.value}`, payload);
}
